import React, { FC, useCallback } from "react";

import {
    GoogleBusinessProfile,
    OnboardingAside,
    OnboardingContent,
    Place,
    PrimaryAlternateControl,
} from "@xapp/components";

export interface ConfirmProfileStepProps {
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;
    /**
     * Whether the business is loading
     */
    loading: boolean;
    /**
     * The place to confirm
     */
    place?: Place;
    /**
     * User confirms the place
     */
    onConfirm(place: Place): void;
    /**
     * User wants to search again
     */
    onSearchAgain(): void;
}

export const ConfirmProfileStep: FC<ConfirmProfileStepProps> = (props) => {
    const { aside, loading, place, onConfirm, onSearchAgain } = props;

    const handlePrimary = useCallback(() => {
        if (place) {
            onConfirm(place);
        }
    }, [onConfirm, place]);

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                <h3>Is this your Google Business Profile?</h3>
                <GoogleBusinessProfile loading={loading || !place} place={place} showContact={true} />
                <PrimaryAlternateControl
                    labels={{
                        primary: "Yes, train my agent",
                        alternate: "No, search again",
                    }}
                    onPrimary={handlePrimary}
                    onAlternate={onSearchAgain}
                />
            </OnboardingContent>
        </>
    );
};
